
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import SpecialsScreen from './specials';
import ListProducts from './ListProducts';

function Index({dishs2, setShowHappy}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

     const [showSpecials, setShowSpecials] = useState(false);

    const [showListProduct, setShowListProduct] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [menus, setMenus] = useState([]);
    const [dataSignatureCocktails, setdataSignatureCocktails] = useState(false);
    const [dataTraditionalCocktails, setdataTraditionalCocktails] = useState(false);
    const [dataMocktails, setdataMocktails] = useState(false);
    const [dataMojitos, setdataMojitos] = useState(false);

     useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
     }, []);
    
    
    useEffect(() => {
        menus.map((item) => {
            if (item.id === 705) {
                setdataSignatureCocktails(item);
            }
            if (item.id === 707) {
                setdataTraditionalCocktails(item);
            }
            if (item.id === 708) {
                setdataMocktails(item);
            }
            if (item.id === 706) {
                setdataMojitos(item);
            }
        });
    }, [menus]);

    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} setShowSpecials={setShowSpecials} setShowListProduct={setShowHappy}>
                <div  style={{padding: '0 20px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                    <br/>


                    <img onContextMenu={(e) => e.preventDefault()}
                        src={require('./assets/bottles/texto-cognac.png')}
                        style={{
                            width: '100%',
                            height: 300,
                            pointerEvents: 'none',
                            objectFit: 'contain',
                            zIndex: 0,
                            marginTop: 200,
                            marginLeft: -100
                                                    
                        }} />
                    

                    
                    <br/>
                   
                    
                   
                    

                </div>


               
                

                {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}
                
                 {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowHappy} />}
            </LayoutContent>

             <img onContextMenu={(e) => e.preventDefault()}
                        src={require('./assets/bottles/botellas-cognac.png')}
                        style={{
                            width: '100%',
                            height: 600,
                            pointerEvents: 'none',
                            objectFit: 'contain',
                            zIndex: 0,
                            marginTop: 200,
                            position: 'absolute',
                            top: 0,
                            right: -280,
                    }} />
        </div>
    );
}
export default Index;